<div id="list-documents" *ngIf="templateView==1">
    <h2 class=" font-weight-bolder"><i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "GENERAL.DOCUMENTS" | translate }}</h2>

    <div class="card card-custom gutter-b mt-10">
        <div class="card-body py-0 px-0">
            <!--div class="row mx-3">
                <div class="col-md-12 my-5">
                    <span class="font-weight-boldest font-size-h6 text-dark-50">{{ "MENU.DOCUMENTS" | translate}}</span>
                </div>
            </!--div -->

            <div class="form-group row mt-5 mx-3 justify-content-md-left">
                <div class="col-md-12">
                    <p class="font-weight-boldest">Estimado cliente,</p>
                    <p>Le ofrecemos la oportunidad de enviar y actualizar documentos necesarios para realizar gestiones asociadas a sus pólizas y Control de Legimitación de Capitales.</p>
                    <p>Para enviar un documento, siga satisfactoriamente los siguientes pasos:</p>
                    <ul class="list-none format1">
                        <li><i class="fa fa-check-circle text-success "></i> Los archivos enviados pasaran por un proceso de verificación para su posterior visualización por el sistema.</li>
                        <li><i class="fa fa-check-circle text-success"></i> Una vez recibidos y verificados los documentos estarán disponibles en línea en un lapso de 48 Horas hábiles.</li>
                    </ul>
                </div>
            </div>

            <div class="separator separator-solid separator-border-2 separator-light"></div>

            <form id="document-upload" name="document-upload">
                <div class="row my-5 justify-content-md-center">
                    <div class="col-md-8 col-sm-12">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <div class="input-group input-group-">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text min-width font-uppercase font-weight-boldest bg-gray-light text-white">{{ "DOCUMENTS.TYPE" | translate }}</span>
                                        </div>
                                        <select class="form-control" name="documentType" >
                                            <option value="">{{ "DOCUMENTS.TYPE" | translate }}</option>
                                            <option value="1">{{ "DOCUMENTS.CEDULA" | translate }}</option>
                                            <option value="2">{{ "DOCUMENTS.PASAPORTE" | translate }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 mt-5">
                                <div class="input-group is-invalid">
                                    <div class="custom-file">
                                    <input type="file" class="custom-file-input" id="validatedInputGroupCustomFile" required>
                                    <label class="custom-file-label" for="validatedInputGroupCustomFile">{{ "DOCUMENTS.DOCUMENT" | translate }}</label>
                                    </div>
                                    <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button">{{ "DOCUMENTS.UPLOAD_REQUIRED_DOCUMENT" | translate }}</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 texgt-center my-4">
                                <p class=" texgt-center  font-weight-boldest "><strong>{{ "DOCUMENTS.HELP_1" | translate }}</strong></p>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        </div>
    </div>
</div>